import { useEffect } from 'react';
import { useLocation } from 'react-router';
const MoveToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        // @ts-ignore
        window.scroll({ top: 0, left: 0, behavior: 'instant' });
    }, [pathname]);
    return null;
};
export default MoveToTop;
//# sourceMappingURL=MoveToTop.js.map